export default __webpack_public_path__ + "media/images/react_icons/arrow-left-black-d8124ccf72625f2cdfb55ad894684e1b.svg";